import React, { useState } from 'react';

const tabs = [
  { id: 'overview', label: '📖 Overview' },
  { id: 'category', label: '🏷️ Category Creator' },
  { id: 'digitalLearning', label: '💻 Literacy & Audit' },
  { id: 'leanSigma', label: '⚙️ Micro Lean Sigma' },
  { id: 'growthEngine', label: '🚀 Growth Engine' },
  { id: 'stage1-4', label: '📚 Staged Adoption' },
  { id: 'digitalKits', label: '🎒 Digital Kits' },
  { id: 'referral', label: '🔗 ValueShare' },
  { id: 'gamification', label: '🏆 Rewards' },
  { id: 'managedServices', label: '🤝 Managed Services' },
  { id: 'microERP', label: '📊 Micro ERP & Integra' },
  { id: 'community', label: '🌐 Community Engagement' },
  { id: 'pricing', label: '🚀💰 Pricing' },
  { id: 'msmeinindia', label: '🎯 MSME in India' },
  { id: 'journey', label: '👥 TaaP' },
  { id: 'ami', label: '👁️ AMI' },
  { id: 'sickunit', label: '❌ Sick MSMEs' },
  { id: 'pmmy', label: '🎒 PMMY' },

];



const MSMEVisionPage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-black text-gray-200 font-sans">
      <header className="bg-black border-b border-blue-400 text-white p-4 text-center">
        <h1 className="text-lg lg:text-xl font-bold">SAKSHAM Bharat SAKSHAM MSMEs!</h1>
        <p className="text-xs lg:text-sm mt-1">
          Powered by Think5Whys Global DeepTech Solutions, Mumbai | Made In India, Made for India & The World
        </p>
      </header>

      {/* <nav className="bg-black border-b border-gray-200 p-2">
        <div className="grid grid-cols-3 lg:grid-cols-8 gap-2 place-items-center">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full text-center px-3 py-2 text-xs lg:text-xs font-medium rounded-md  
                ${
                  activeTab === tab.id
                    ? 'bg-teal-800 text-yellow-200 border-b-2 border-indigo-600'
                    : 'text-white hover:bg-teal-700'
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </nav> */}

      <nav className="bg-black border-b border-gray-800 px-2 py-3">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-2">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full h-10 flex items-center justify-center rounded-lg text-xs font-semibold transition
                  ${
                    isActive
                      ? 'bg-teal-800 text-yellow-200 ring-1 ring-indigo-500'
                      : 'bg-gray-900 text-gray-300 hover:bg-teal-700 hover:text-white'
                  }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </nav>


      <div className="p-4 space-y-3 lg:space-y-8 bg-black">
        {activeTab === 'overview' && (
          <>
          <div className="space-y-4 text-white">
            <h2 className="text-lg lg:text-lg font-semibold text-yellow-200">About SAKSHAM & Think5Whys</h2>
            <p className='text-white'>
              SAKSHAM stands for <strong>Skilled And Keen Systematic Hands Achieves More!</strong> Think5Whys is a category creator serving billions of people and millions of entities worldwide.
            </p>
            <p className='text-white'>
              It leverages innovative Transformation-as-a-Platform, aiming to empower individuals, MSMEs, farmers, students, teachers, institutions, and government employees.
            </p>
          </div>
          <div className="bg-black text-white p-5 rounded-md shadow-md">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Ecosystem Players</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>MSME Owners (Micro & Small Enterprises)</li>
              <li className='text-xs lg:text-sm'>Banks & NBFCs (HDFC, SBI, SIDBI, etc.)</li>
              <li className='text-xs lg:text-sm'>ARCs (Asset Reconstruction Companies)</li>
              <li className='text-xs lg:text-sm'>Government & Development Agencies (MSME Ministry, Atal Innovation Mission, NSIC, etc.)</li>
              <li className='text-xs lg:text-sm'>Industry Associations & Clusters (CII, FICCI, local chambers, cluster bodies)</li>
              <li className='text-xs lg:text-sm'>Corporate Supply Chains (buyers from manufacturing, retail, logistics, IT, pharma, etc.)</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Current Pain Points</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'><strong>MSMEs:</strong> Low management literacy, owner-driven operations, weak digital adoption, poor process maturity.</li>
              <li className='text-xs lg:text-sm'><strong>Banks/NBFCs:</strong> High MSME NPA rates, weak credit monitoring.</li>
              <li className='text-xs lg:text-sm'><strong>ARCs:</strong> Limited revival tools beyond financial restructuring → low recovery rates.</li>
              <li className='text-xs lg:text-sm'><strong>Government/Associations:</strong> Training exists but lacks structured, scalable management literacy & execution model.</li>
              <li className='text-xs lg:text-sm'><strong>Corporates:</strong> Supplier MSMEs lack consistency, quality discipline, ESG readiness.</li>
            </ul>
          </div>
          <div className="bg-black text-white p-5 rounded-md shadow-md">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Vision</h2>
            <p className="text-white">
              SAKSHAM MSME aims to transform India’s micro & small enterprises into resilient growth engines through literacy, productivity, digital adoption, and systematic support.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Empower MSME owners with structured tools and frameworks</li>
              <li className='text-xs lg:text-sm'>Bridge literacy, digital readiness, and execution support</li>
              <li className='text-xs lg:text-sm'>Enable job creation and economic growth</li>
              <li className='text-xs lg:text-sm'>Leverage Think5Whys Transformation-as-a-Platform for sustainable impact</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Mission</h2>
            <p className="text-white text-xs lg:text-sm">
              Think5Whys is pioneering four breakthrough categories:
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Immersive Digital Literacy & Big Data Learning</li>
              <li className='text-xs lg:text-sm'>Micro Lean Sigma Transformation for Individuals to Blue-Collar Workers</li>
              <li className='text-xs lg:text-sm'>Purple Power Deep Thinking for High Schoolers</li>
              <li className='text-xs lg:text-sm'>SAKSHAM Growth Engine for MSMEs & Farmers creating over 2.5 crore jobs</li>
            </ul>
            <p className="text-white text-xs lg:text-sm">
              The vision is to become a $250 billion global enterprise from India by 2035 by solving only 5% of intended users.
            </p>
          </div>
          <div className="bg-black text-white p-5 rounded-md shadow-md">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Core Values</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Empowerment — Tools for self-reliance.</li>
              <li className='text-xs lg:text-sm'>Innovation — Digital and process transformation.</li>
              <li className='text-xs lg:text-sm'>Collaboration — Ecosystem partnerships.</li>
              <li className='text-xs lg:text-sm'>Excellence — Measurable outcomes.</li>
              <li className='text-xs lg:text-sm'>Inclusivity — Access for all MSMEs.</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Target Users</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>5+ billion Individual users</li>
              <li className='text-xs lg:text-sm'>400 million Micro & Small Enterprises (MSMEs)</li>
              <li className='text-xs lg:text-sm'>2.5 billion Blue-Collar Workers</li>
              <li className='text-xs lg:text-sm'>800 million Farmers</li>
              <li className='text-xs lg:text-sm'>1.5 billion Students</li>
              <li className='text-xs lg:text-sm'>150 million Teachers</li>
              <li className='text-xs lg:text-sm'>10 million Institutions</li>
              <li className='text-xs lg:text-sm'>150 million Government Employees worldwide</li>
            </ul>
          </div>
          <div className="bg-black text-white p-5 rounded-md shadow-md">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Expected Outcomes</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Increased MSME survival and growth rates</li>
              <li className='text-xs lg:text-sm'>Improved credit flow and recovery in financial systems</li>
              <li className='text-xs lg:text-sm'>Enhanced competitiveness and sustainability of MSMEs</li>
              <li className='text-xs lg:text-sm'>Stronger Atmanirbhar Bharat backbone through digitally-ready enterprises</li>
              <li className='text-xs lg:text-sm'>Structured knowledge dissemination and certification for owners</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">SAKSHAM MSME Ecosystem Map</h2>
            <p className="text-white">
              Positioning: <strong>SAKSHAM MSME by Think5Whys</strong> is a Management OS + Management-as-a-Service (MaaS) model that empowers MSMEs at scale, bridging literacy, digital readiness, and execution support.
            </p>
            <p className="text-white">
              Focuses on transforming micro & small enterprises into resilient growth engines, catering to individuals, families, institutions, enterprises, workers, students, MSMEs, and government entities.
            </p>
            <p className="text-white">
              Quality Certification Roadmap includes ISO 9001 (Quality), ISO 27001 (Security), SOC 1 & 2 (Data Integrity & Compliance).
            </p>
          </div>  
          </>
        )}

        {activeTab === 'category' && (
          <div className="space-y-3 p-4">
            <div className="text-center">
              <h1 className="text-xl lg:text-2xl font-bold text-gray-300 dark:text-white mb-2">Think5Whys Strategic Placement as Category Creator</h1>
              <p className="text-sm lg:text-base text-gray-100 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
                A brief on what Think5Whys is for 5+ billion users worldwide, including 400 million Micro & Small Enterprises, 2.5 billion Blue-Collar Workers, 800 million Farmers, 1.5 billion Students, 150 million Teachers, 10 million Institutions, and 150 million Government Employees:
                <br />
                <span className="font-semibold text-yellow-200">“Think5Whys is a Transformation-as-a-Platform pioneering four breakthrough categories—Immersive Digital Literacy & Big Data Learning, Micro Lean Sigma Transformation for Individuals to Blue-Collar Workers, Purple Power Deep Thinking for High Schoolers, and SAKSHAM Growth Engine for MSMEs & Farmers creating over 2.5 crore jobs.”</span>
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">The Six Potential Breakthrough Categories</h2>
              <div className="space-y-4">
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-300 dark:text-white mb-2">Category 1: Immersive Digital Literacy & Big Data Learning</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300">An integrated way to create, publish, talk, note, and learn—multilingual, engagement-driven, and powered by Big Data insights to transform literacy and knowledge sharing across society.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-300 dark:text-white mb-2">Category 2: Micro Lean Sigma Transformation</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300">A reimagined 4-Stage Lean Six Sigma framework designed for Individuals, Families, Micro-Enterprises, and Blue-Collar Workers—making structured transformation accessible to everyone.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-300 dark:text-white mb-2">Category 3: Purple Power – Deep Thinking for High Schoolers</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300">An innovative Micro Lean Sigma model that cultivates critical thinking and problem-solving skills in young minds, preparing the next generation of deep thinkers.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-300 dark:text-white mb-2">Category 4: SAKSHAM Growth Engine</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">(Skilled and Keen Systematic Hand Achieves More) A platform for MSMEs & Farmers to scale systematically, potentially generating 2.5 crore+ jobs and driving India’s and the Global South’s economic transformation.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-300 dark:text-white mb-2">Category 5: ContactGenius</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">ContactGenius is a smart contact-intelligence platform that transforms static contacts into living, shareable digital identities—creating a new category by fusing contact management, personal branding, and AI-powered context in one system.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-300 dark:text-white mb-2">Category 6: IceBreaker</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">IceBreaker is an AI-powered conversation catalyst that helps people safely reopen difficult conversations—positioning itself as a new category between chat, therapy, and productivity by transforming conflict resolution into a guided, consent-first, scalable experience.</p>
                </div>                                
              </div>
            </div>

            <div className="space-y-4 bg-gray-800 p-4 rounded-md border border-gray-200">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Category Creator vs Innovator/Leader</h2>
              <ul className="list-disc list-inside space-y-1 text-sm text-white dark:text-gray-300">
                <li className='text-xs lg:text-sm'><strong>Category Creator:</strong> Invents a new mental “shelf” globally, framing a problem + solution that didn’t exist before.</li>
                <li className='text-xs lg:text-sm'><strong>Category Innovator:</strong> Improves or scales an existing category in a unique way.</li>
                <li className='text-xs lg:text-sm'><strong>Category Leader:</strong> Dominates an existing category, maybe with incremental innovation.</li>
              </ul>
              <p className="text-sm text-gray-100 dark:text-gray-400 mt-3">
                Think5Whys sees global opportunities to become a $250 billion global enterprise from India by 2035 by solving only 5% of the intended users.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Global Category-Creating Platforms</h2>
              <p className="text-sm text-gray-100 dark:text-gray-400">Each of these invented a mental “shelf” in the market. They solved an unmet need in a unique way and framed a new category. Many scaled globally because they owned the problem definition first, not just the product.</p>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-xs lg:text-sm">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">#</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Company</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Category Created</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Country</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Founded</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Revenue (2023)</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Valuation (2025)</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Remarks</th>
                    </tr>
                  </thead>
                  <tbody className="bg-black dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">1</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Salesforce</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Cloud CRM / SaaS</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">1999</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$31.35B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$206B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Dominant in enterprise CRM; pioneered SaaS model.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Slack</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Team messaging / collaboration platform</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2013</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$1.7B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Acquired by Salesforce for $27.7B in 2021</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Revolutionized workplace communication; now integrated into Salesforce.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">3</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Zoom</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Cloud-first video communication</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2011</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$4.67B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$25.2B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Became essential during the pandemic; maintains strong enterprise adoption.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">4</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Twilio</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Communication APIs (CPaaS)</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2008</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$4.73B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$16.3B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Powers messaging and voice for thousands of apps; leader in CPaaS.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">5</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Stripe</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Developer-first payments APIs</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2011</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$3.8B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $50B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Facilitates $1T+ in annual transactions; essential for online businesses.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">6</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">GitHub</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Collaborative code hosting / Dev platform</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2008</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$2B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Acquired by Microsoft for $7.5B in 2018</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Central to modern software development; strong AI integration with Copilot.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">7</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Notion</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Connected workspace (notes+DB+tasks)</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2013</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$400M</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $10B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Combines note-taking, databases, and tasks; rapidly adopted in teams and education.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">8</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Uber</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">On-demand ride-hailing</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2009</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$43.98B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$82B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Transformed urban mobility; now expanding into delivery and freight.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">9</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Airbnb</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Peer-to-peer home sharing</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2008</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$8.4B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$80B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Disrupted the hospitality industry; diversifying into experiences and luxury stays.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">10</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">DoorDash</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">On-demand food delivery as platform</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2013</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$7.5B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$30B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Leading food delivery service in the U.S.; expanding into new verticals.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">11</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Coursera</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">MOOCs</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2012</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$500M</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$2.5B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Partners with top universities; offers accredited degrees and certificates.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">12</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Duolingo</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Gamified micro-learning</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2011</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$252M</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$6.5B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Popular language learning app; integrating AI features for personalized learning.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">13</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Khan Academy</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Free online learning platform</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2008</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Non-profit</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Provides free education globally; widely used in schools and homes.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">14</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">MasterClass</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Celebrity-led skill-learning platform</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2015</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $1B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Offers classes taught by celebrities; unique approach to online education.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">15</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Outschool</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Live small-group online classes</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2015</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $1B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Focuses on K-12 education; offers a wide range of subjects and activities.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">16</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Lambda / BloomTech</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Income-share-agreement coding school</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2017</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $1B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Provides tech education with deferred tuition; aims to increase accessibility.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">17</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Brainly</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Peer-to-peer homework help</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Poland</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2009</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $1B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Offers a platform for students to help each other with homework; expanding globally.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">18</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Canva</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">DIY design for non-designers</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Australia</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2012</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$1B+</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$40B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Simplifies graphic design; widely used by individuals and businesses.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">19</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">TikTok</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Short-form AI-personalized social video</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">China</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2016</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$11B</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">$100B</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Dominates short-form video content; heavily integrated with AI for content delivery.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">20</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Substack</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Paid newsletter / creator economy</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2017</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $1B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Empowers writers to monetize directly; growing creator-led content platform.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">21</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Kiva</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Peer-to-peer micro-lending</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2005</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Non-profit</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Facilitates microloans globally; focuses on underserved entrepreneurs.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">22</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">M-Pesa</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Mobile money & financial inclusion</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Kenya</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2007</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Non-profit</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Revolutionized mobile payments in Africa; widely adopted for financial transactions.</td>
                    </tr>
                    <tr>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">23</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Clubhouse</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Live social audio</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">USA</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">2020</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Not disclosed</td>
                      <td className="px-2 lg:px-6 py-4 whitespace-nowrap text-gray-300 dark:text-white">Estimated $1B+</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Introduced drop-in audio conversations; sparked a new trend in social media interaction.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="bg-black p-4 rounded-lg border border-blue-200 dark:border-blue-800">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200 mb-3">🔑 Key Points</h3>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 text-sm">
                <div>
                  <h4 className="font-medium text-gray-300 dark:text-white mb-1">Revenue & Valuation</h4>
                  <p className="text-gray-100 dark:text-gray-300">These companies have demonstrated significant financial growth, with revenues ranging from hundreds of millions to billions and valuations often exceeding $1 billion, indicating their dominant positions in their respective categories.</p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-300 dark:text-white mb-1">Market Impact</h4>
                  <p className="text-gray-100 dark:text-gray-300">These companies have not only created new categories but have also redefined existing ones, leading to widespread adoption and significant market influence.</p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-300 dark:text-white mb-1">Innovation Drivers</h4>
                  <p className="text-gray-100 dark:text-gray-300">Their success is attributed to continuous innovation, user-centric designs, and the ability to scale rapidly in the digital age.</p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">India's Category Creators</h2>
              <p className="text-sm text-gray-100 dark:text-gray-400">India has very few global-scale category creators. Most startups are category leaders or innovators. Though India has Infrastructure-level innovations, like UPI / India Stack, are category creators because they invented a new system / category that the world hadn’t seen at this scale.</p>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-xs lg:text-sm">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Company</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Category Created</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Remarks</th>
                      <th className="px-2 lg:px-6 py-3 text-left font-medium text-gray-300 dark:text-white">Impact</th>
                    </tr>
                  </thead>
                  <tbody className="bg-black dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                    <tr>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">India Stack (UIDAI, UPI, Aadhaar)</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Universal digital identity & instant interoperable payments for a billion+ users.</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">India Stack and UPI arguably created a new infrastructure category, enabling fintech ecosystems that didn’t exist before. This is a rare Indian category creation.</td>
                      <td className="px-2 lg:px-6 py-4 text-gray-300 dark:text-white">Billions of transactions annually; basis for multiple Indian unicorns.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="space-y-4 p-2 border border-blue-400">
              <h2 className="text-sm lg:text-lg font-semibold p-4 text-yellow-200">Analysis of Think5Whys 6 Categories</h2>
              <div className="space-y-4">
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base font-semibold text-yellow-200 mb-2">Immersive Digital Literacy & Big Data Learning</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Novelty: Combines digital literacy, multilingual content, talking notes, engagement analytics, and Big Data-driven insights.</p>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Global Stage: There are MOOCs, Duolingo, Khan Academy, and learning analytics platforms, but no fully integrated literacy platform for all ages and segments.</p>
                  <p className="font-semibold text-green-200 dark:text-green-400">Verdict: Potential global category creator.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base font-semibold text-yellow-200 mb-2">Micro Lean Sigma Transformation (Individuals to Blue-Collar Workers)</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Novelty: Applying Lean Six Sigma to individuals, families, micro-enterprises, and blue-collar workers is unique; globally, Lean is enterprise-focused.</p>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Global Stage: No known platform democratizes Lean Six Sigma for these segments.</p>
                  <p className="font-semibold text-green-200 dark:text-green-400">Verdict: True category creation potential globally.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base font-semibold text-yellow-200 mb-2">Purple Power – Deep Thinking for High Schoolers</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Novelty: Structured Micro Lean Sigma applied to critical thinking and problem-solving for teenagers.</p>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Global Stage: No global platform treats high school students as a “deep thinking category” in a systematic framework.</p>
                  <p className="font-semibold text-green-200 dark:text-green-400">Verdict: Global category creator potential.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base font-semibold text-yellow-200 mb-2">SAKSHAM – MSME Growth Engine</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Novelty: Platform for MSMEs/farmers combining systematic growth, skill development, and job creation at scale.</p>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Global Stage: Platforms exist for MSME services, but not with integrated growth + job creation + systemic skill development at this scale.</p>
                  <p className="font-semibold text-green-200 dark:text-green-400">Verdict: Global category creation potential, especially for emerging markets.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base font-semibold text-yellow-200 mb-2">ContactGenius</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Novelty: Turns ordinary contacts into intelligent, interactive digital identities instead of static name–number entries.</p>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Global Stage: Designed for universal use across professionals, MSMEs, students, creators, and enterprises with instant shareability.</p>
                  <p className="font-semibold text-green-200 dark:text-green-400">Verdict: A strong category creator redefining how humans store, share, and experience contacts.</p>
                </div>
                <div className="bg-gray-800 p-4 rounded-md border border-gray-200">
                  <h3 className="text-base font-semibold text-yellow-200 mb-2">IceBreaker</h3>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Novelty: AI-powered, consent-first conversation catalyst that operates in the pre-therapy, pre-conflict-resolution space—guiding humans to reconnect before damage becomes permanent.</p>
                  <p className="text-sm text-gray-100 dark:text-gray-300 mb-2">Global Stage: Universally relevant across cultures, workplaces, families, education, and self-reflection—conflict is a human constant, and IceBreaker scales it digitally.</p>
                  <p className="font-semibold text-green-200 dark:text-green-400">Verdict:     Verdict: Category Creator — Positioned between Chat, Therapy, and Productivity tools, with strong potential for mass adoption and platform expansion.</p>
                </div>                             
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Summary</h2>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left font-medium text-gray-300 dark:text-white">Category</th>
                      <th className="px-4 py-3 text-left font-medium text-gray-300 dark:text-white">Global Category Creation Potential</th>
                      <th className="px-4 py-3 text-left font-medium text-gray-300 dark:text-white">Notes</th>
                    </tr>
                  </thead>
                  <tbody className="bg-black dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                    <tr>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Immersive Digital Literacy & Big Data Learning</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">High</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Combines multiple existing tools into a first-of-its-kind literacy platform</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Micro Lean Sigma Transformation</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">High</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Democratizes Lean Six Sigma globally to individuals & blue-collar workers</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Purple Power – Deep Thinking</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">High</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Structured critical thinking for high schoolers is unique</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">SAKSHAM – MSME Growth Engine</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">High</td>
                      <td className="px-4 py-3 text-gray-300 dark:text-white">Integrated MSME growth + job creation + skill development globally</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-gray-100 dark:text-gray-400 text-center">
                Think5Whys is not merely a category innovator or leader; it has the potential to create 6 new categories globally. This is rare, especially for an Indian-origin platform. Most Indian startups are category leaders/innovators, so Think5Whys could stand out as a global category creator.
              </p>
            </div>
          </div>
        )}

        {activeTab === 'digitalLearning' && (
          <>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Immersive Digital Literacy & Big Data Learning</h2>
            <p className="text-white">
              An integrated way to create, publish, listen, note, and learn—multilingual, engagement-driven, and powered by Big Data insights to transform literacy and knowledge sharing across society.
            </p>
            <p className="text-white">
              Focuses on **digital readiness**, **learning engagement**, and **knowledge empowerment** for individuals and MSMEs.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Self-Audit Tools</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>MSME Digital Readiness & BPM Maturity Evaluation</li>
              <li className='text-xs lg:text-sm'>Productivity Self Audit</li>
              <li className='text-xs lg:text-sm'>BPM & Process Compliance Self Audit</li>
              <li className='text-xs lg:text-sm'>Cybersecurity Self Audit</li>
            </ul>
          </div>
          </>
        )}

        {activeTab === 'leanSigma' && (
          <>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Micro Lean Sigma Transformation</h2>
            <p className="text-white">
              A reimagined 4-Stage Lean Six Sigma framework designed for Individuals, Families, Micro-Enterprises, and Blue-Collar Workers—making structured transformation accessible to everyone.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Stage 1: Awareness & Education</li>
              <li className='text-xs lg:text-sm'>Stage 2: Implementation in Daily Work</li>
              <li className='text-xs lg:text-sm'>Stage 3: Process Optimization</li>
              <li className='text-xs lg:text-sm'>Stage 4: Sustainable Continuous Improvement</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Purple Power – Deep Thinking for High Schoolers</h2>
            <p className="text-white">
              An innovative Micro Lean Sigma model that cultivates critical thinking and problem-solving skills in young minds, preparing the next generation of deep thinkers.
            </p>
            <p className="text-white">
              Focused on **structured thinking**, **creativity**, and **decision-making skills** for students.
            </p>
          </div>  
          </>
        )}

        {activeTab === 'growthEngine' && (
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">SAKSHAM Growth Engine</h2>
            <p className="text-white">
              (Skilled and Keen Systematic Hand Achieves More) – A platform for MSMEs & Farmers to scale systematically, potentially generating 2.5 crore+ jobs and driving India’s and the Global South’s economic transformation.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Management Literacy & Execution Support</li>
              <li className='text-xs lg:text-sm'>Cloud-based Productivity & BPM Tools</li>
              <li className='text-xs lg:text-sm'>Managed Services (MaaS) for SMEs</li>
              <li className='text-xs lg:text-sm'>MSME Metaverse & UdyamVerse for cluster-based collaboration</li>
            </ul>
          </div>
        )}

       {activeTab === 'stage1-4' && (
        <div className="space-y-3">
          {[
            {
              title: 'Stage 1: Management Literacy',
              text: 'Digital books, toolkits & frameworks covering:',
              list: [
                'Financial literacy',
                'Legal basics',
                'Root Cause Analysis (RCA) & RACI',
                'Six Sigma lite & Design of Experiments (DOE)',
                'Cybersecurity, Productivity hacks, Innovation, ESG, Marketing & Sales'
              ],
              footer: 'Builds foundational knowledge for MSME owners to operate smarter and more efficiently.'
            },
            {
              title: 'Stage 2: Cloud Productivity Platform',
              text: 'Self & team work management tools providing:',
              list: [
                'Digital readiness & BPM maturity evaluation',
                'Daily tracking & immersive learning',
                'Collaboration & process discipline'
              ],
              footer: 'Enables MSMEs to shift from owner-centric to process-centric operations.'
            },
            {
              title: 'Stage 3: Managed Services (MaaS)',
              text: 'Shared micro-consultants trained in Lean Six Sigma & process oversight provide:',
              list: [
                'Periodic support beyond accounting/ERP',
                'Process quality, efficiency, compliance, governance',
                'Affordable management bandwidth for MSMEs'
              ]
            },
            {
              title: 'Stage 4: MSME Metaverse',
              text: 'UdyamVerse: Metaverse platform for Indian MSME clusters, combining virtual environments, real-time collaboration, and blockchain transactions.',
              list: [
                'Cluster-based commerce, networking, and training',
                'Shared resources and collective growth',
                'Localized impact aligned with Atmanirbhar Bharat vision'
              ]
            }
          ].map(stage => (
            <div key={stage.title} className="space-y-4">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">{stage.title}</h2>
              <p className="text-white">{stage.text}</p>
              <ul className="list-disc list-inside space-y-1">
                {stage.list.map(item => <li key={item}>{item}</li>)}
              </ul>
              {stage.footer && <p className="text-white">{stage.footer}</p>}
            </div>
          ))}
        </div>
      )}

        {activeTab === 'digitalKits' && (
          <>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">SAKSHAM MSME Digital Kits</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Startup Kit with 220+ ready-to-use business templates</li>
              <li className='text-xs lg:text-sm'>MSME Awareness / Literacy & Productivity Kit</li>
              <li className='text-xs lg:text-sm'>Cloud-based productivity & management tools</li>
              <li className='text-xs lg:text-sm'>AI-powered insights and digital guides</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Digital Books & Guides</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Purple Power: Six Sigma for MSMEs</li>
              <li className='text-xs lg:text-sm'>Financial Literacy Digital Book</li>
              <li className='text-xs lg:text-sm'>Cyberwisdom: Cybersecurity Awareness</li>
              <li className='text-xs lg:text-sm'>RCA: Root Cause Analysis & Problem-Solving</li>
              <li className='text-xs lg:text-sm'>MSME Loans Demystified</li>
              <li className='text-xs lg:text-sm'>DOE (Design of Experiments) Literacy Kit for Manufacturing MSMEs</li>
            </ul>
          </div>
          </>
        )}

        {activeTab === 'referral' && (
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Referral Program</h2>
            <p className="text-white">
              Multilevel matrix referral program providing active & passive income opportunities for MSMEs & startup owners.
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>8-level referral mechanism</li>
              <li className='text-xs lg:text-sm'>Rewards for promoting Think5Whys programs</li>
              <li className='text-xs lg:text-sm'>Encourages community growth and knowledge dissemination</li>
            </ul>
          </div>
        )}

        {activeTab === 'gamification' && (
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Gamification & Rewards</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>SAKSHAM MSME Awards: Best MSMEs selected transparently</li>
              <li className='text-xs lg:text-sm'>MindSpark Awards for self & family</li>
              <li className='text-xs lg:text-sm'>Marksheet Contest for Children</li>
              <li className='text-xs lg:text-sm'>Kharcho-Jeeto: Upload daily expenses and win prizes</li>
              <li className='text-xs lg:text-sm'>Encourages continuous engagement and motivation</li>
            </ul>
          </div>
        )}

        {activeTab === 'managedServices' && (
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Managed Services</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Shared resources of trained professionals</li>
              <li className='text-xs lg:text-sm'>24x7 consulting service</li>
              <li className='text-xs lg:text-sm'>DeepTech implementation (AI, IIOT, Blockchain, XAI)</li>
              <li className='text-xs lg:text-sm'>Online workshops & trainings</li>
              <li className='text-xs lg:text-sm'>Access to MSME-focused events and legal/funding solutions</li>
            </ul>
          </div>
        )}

        {activeTab === 'microERP' && (
          <>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Micro & Startup ERP</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Inventory & Materials Management</li>
              <li className='text-xs lg:text-sm'>Simple Production/Job Tracking</li>
              <li className='text-xs lg:text-sm'>Sales & Orders (CRM, quotations → invoices)</li>
              <li className='text-xs lg:text-sm'>Purchase & Vendor Management</li>
              <li className='text-xs lg:text-sm'>Finance Lite (cashflow, payables/receivables, GST-ready)</li>
              <li className='text-xs lg:text-sm'>Problem-solving layer with 5 Whys integration</li>
              <li className='text-xs lg:text-sm'>Micro-friendly UI for mobile/shop floor use</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Integra (Integration Layer)</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Seamless integration with existing MSME systems (ERP, CRM, POS)</li>
              <li className='text-xs lg:text-sm'>Zero duplication of data</li>
              <li className='text-xs lg:text-sm'>Unified workflow for faster decisions</li>
              <li className='text-xs lg:text-sm'>Future-ready for marketplaces, compliance portals, IoT devices</li>
            </ul>
          </div>
          </>
        )}

        {activeTab === 'community' && (
          <>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">MSME & Startup Community Engagement</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Podcasts for MSMEs & aspiring founders</li>
              <li className='text-xs lg:text-sm'>Online events and workshops (AI, RCA, Productivity, BPM, Digital Maturity)</li>
              <li className='text-xs lg:text-sm'>Active community interaction & support via Think5Whys platform</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">UdyamVerse / MSME Metaverse</h2>
            <p className="text-white">
              A metaverse platform for clustered MSMEs, enabling:
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Virtual environments for collaboration & training</li>
              <li className='text-xs lg:text-sm'>Blockchain-based transactions & commerce</li>
              <li className='text-xs lg:text-sm'>Shared resources and collective growth</li>
              <li className='text-xs lg:text-sm'>Localized impact aligned with Atmanirbhar Bharat vision</li>
            </ul>
          </div>
          </>
        )}

        {activeTab === 'pricing' && (
          <>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Go-To-Market (GTM) Strategy</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>B2C: Direct engagement with MSME owners and startups</li>
              <li className='text-xs lg:text-sm'>B2B2C: Partnerships with Banks, NBFCs, Industry Associations</li>
              <li className='text-xs lg:text-sm'>C2C: Referral programs for community-based growth</li>
              <li className='text-xs lg:text-sm'>G2C: Collaboration with Government & Development Agencies</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Freemium & Paid Pricing</h2>
            <ul className="list-disc list-inside space-y-1">
              <li className='text-xs lg:text-sm'>Freemium Awareness / Literacy & Productivity Kit: ₹0.00</li>
              <li className='text-xs lg:text-sm'>Advanced / Managed Services & Custom Packages: ₹0 - ₹9,999 annually</li>
              <li className='text-xs lg:text-sm'>Additional premium modules available a-la-carte</li>
              <li className='text-xs lg:text-sm'>Affordable, scalable, and outcome-driven pricing model</li>
            </ul>
          </div>
          </>
        )}

        {activeTab === 'msmeinindia' && (
          <div className="space-y-3">

            {/* Section 1: Chronological Evolution */}
            <div className="space-y-2">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Chronological Evolution of MSMEs in India</h2>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>
                  <strong>Pre-Independence (Before 1947):</strong> Traditional artisan & cottage industries; handlooms, handicrafts, khadi; informal economy.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Post-Independence (1947–1970s):</strong> Industrial push; KVIC (1954), SIDO (1960s), import substitution; protected small units.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Liberalization Era (1991–2000):</strong> Exposure to global markets; modernization, quality standards; credit challenges.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>MSME Definition (2006):</strong> MSMED Act; classification by investment; National Board for MSMEs created.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Financial & Digital Inclusion (2010–2019):</strong> Mudra Yojana, Startup India, GST, Digital adoption.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Pandemic Era (2020–2022):</strong> COVID-19 shocks; ECLGS; Udyam Portal; MSME definition revised (investment + turnover criteria).
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Future (2025–2035):</strong> Digital-first MSMEs, smart clusters, global value chain integration, sustainability, FinTech, inclusive entrepreneurship, innovation-driven MSMEs.
                </li>
              </ul>
            </div>

            {/* Section 2: MSME Timeline Summary */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">MSME Timeline Summary</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Pre-1947: Traditional & cottage industries (handicrafts, village economy)</li>
                <li className='text-xs lg:text-sm'>1947–1990: Protection, self-reliance (KVIC, SIDO, License Raj)</li>
                <li className='text-xs lg:text-sm'>1991–2005: Liberalization & exposure (globalization push)</li>
                <li className='text-xs lg:text-sm'>2006: MSMED Act (formal classification)</li>
                <li className='text-xs lg:text-sm'>2010–2019: Financial & digital inclusion (MUDRA, GST, Digital India)</li>
                <li className='text-xs lg:text-sm'>2020–2022: Pandemic resilience (ECLGS, Udyam Portal)</li>
                <li className='text-xs lg:text-sm'>2023–2035: Tech, sustainability, innovation (smart clusters, ESG, fintech)</li>
              </ul>
            </div>

            {/* Section 3: ESG Overview */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">ESG for MSMEs</h3>
              <p className="text-white">ESG stands for Environmental, Social, and Governance — a framework evaluating sustainable and responsible business operations.</p>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>
                  <strong>Environmental:</strong> Carbon emissions, renewable energy, waste management, water conservation, resource efficiency.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Social:</strong> Employee welfare, DEI, human rights, customer safety, community impact.
                </li>
                <li className='text-xs lg:text-sm'>
                  <strong>Governance:</strong> Ethics, board accountability, anti-corruption, tax transparency, internal audits.
                </li>
              </ul>
              <p className="text-white">Benefits: Access to funding, competitiveness in supply chains, global trade readiness, brand trust, sustainability & resilience.</p>
            </div>

            {/* Section 4: Global Opportunity */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Global Opportunity</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Potential $250 billion global enterprise opportunity by 2035.</li>
                <li className='text-xs lg:text-sm'>Targeting only 5% of intended users to create scalable impact.</li>
                <li className='text-xs lg:text-sm'>Serving billions of individuals and millions of MSMEs worldwide.</li>
                <li className='text-xs lg:text-sm'>Category creator approach driving new mental “shelves” globally.</li>
              </ul>
            </div>

          </div>
        )}

        {activeTab === 'journey' && (
          <div className="space-y-3">

            {/* Section 1: Journey Header */}
            <div className="space-y-2">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Adoption → Adaptation → Adjustment → Transition → Transformation</h2>
              <p className="text-white">
                A relatable narration for MSME micro-enterprise owners through Think5Whys Transformation-as-a-Platform (TaaP).
              </p>
            </div>

            {/* Section 2: Story of Ramesh */}
            <div className="space-y-4">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">The Story of Ramesh</h3>
              <p className="text-white">
                Ramesh runs a micro tailoring unit with one helper and two sewing machines. His business is simple but he struggles with irregular customers, rising costs, and lack of systems. Think5Whys TaaP helps him navigate structured growth.
              </p>
            </div>

            {/* Section 3: The 5-Stage Journey */}
            <div className="space-y-4">

              {/* Adoption */}
              <div className="space-y-1">
                <h4 className="text-sm font-semibold text-blue-400">1. Adoption – Literacy Stage</h4>
                <p className="text-white">
                  Awareness & starting point. Through Think5Whys MSME Literacy Kit, Ramesh documents his shop activities in the Think5Whys Chronicle.
                </p>
                <p className="text-white italic">Outcome: Basic visibility into sales, costs, and complaints.</p>
                <p className="text-white">Think5Whys Role: Literacy → showing why structured thinking matters.</p>
              </div>

              {/* Adaptation */}
              <div className="space-y-1">
                <h4 className="text-sm font-semibold text-blue-400">2. Adaptation – Self-Management Stage</h4>
                <p className="text-white">
                  Using RCA, Fishbone & micro Lean Six Sigma tools, Ramesh identifies inconsistencies in profit and adapts by creating checklists and alternative supplier strategies.
                </p>
                <p className="text-white italic">Outcome: Errors reduce and costs come under control.</p>
                <p className="text-white">Think5Whys Role: Self-Management Toolkit → embedding discipline in daily operations.</p>
              </div>

              {/* Adjustment */}
              <div className="space-y-1">
                <h4 className="text-sm font-semibold text-blue-400">3. Adjustment – Resilience Building</h4>
                <p className="text-white">
                  When suppliers raise prices, Ramesh uses Applause to celebrate small wins and capture customer feedback. He introduces design-based pricing to balance cost pressures.
                </p>
                <p className="text-white italic">Outcome: Survival through shocks without losing customers.</p>
                <p className="text-white">Think5Whys Role: Supporting resilience during disruptions.</p>
              </div>

              {/* Transition */}
              <div className="space-y-1">
                <h4 className="text-sm font-semibold text-blue-400">4. Transition – Business Model Shift</h4>
                <p className="text-white">
                  Ramesh analyzes why he is limited to walk-in customers. He joins a Think5Whys marketplace, adds referrals, reselling, and home delivery.
                </p>
                <p className="text-white italic">Outcome: Customer base expands beyond the shop.</p>
                <p className="text-white">Think5Whys Role: Platform guidance → moving from offline to hybrid model.</p>
              </div>

              {/* Transformation */}
              <div className="space-y-1">
                <h4 className="text-sm font-semibold text-blue-400">5. Transformation – Growth & Scale</h4>
                <p className="text-white">
                  Over a year, Ramesh collaborates with 3 tailors, launches a micro-brand, invests in better machines, and tracks KPIs via Think5Whys dashboard.
                </p>
                <p className="text-white italic">Outcome: Jobs created, income multiplies, business identity evolves.</p>
                <p className="text-white">Think5Whys Role: Managed Services → enabling micro-enterprise to micro-brand transformation.</p>
              </div>
            </div>

            {/* Section 4: Journey Summary */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">In Summary (Think5Whys Lens)</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'><strong>Adoption → Literacy (Chronicle)</strong> – saying yes to structured thinking.</li>
                <li className='text-xs lg:text-sm'><strong>Adaptation → Self-Management (Fishbone, RCA)</strong> – embedding practices into operations.</li>
                <li className='text-xs lg:text-sm'><strong>Adjustment → Resilience (Applause)</strong> – tactical tweaks to survive shocks.</li>
                <li className='text-xs lg:text-sm'><strong>Transition → Strategy Shift (Toolkit + Platform Guidance)</strong> – moving to new business models.</li>
                <li className='text-xs lg:text-sm'><strong>Transformation → Managed Services</strong> – fundamental change in business identity and scale.</li>
              </ul>
            </div>

          </div>
        )}


        {activeTab === 'ami' && (
          <div className="space-y-3">

            {/* Main Heading */}
            <div className="space-y-2">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Think5Whys: Beyond AGI — Specialized Intelligence for MSMEs and Transformation</h2>
              <p className="text-white">Think5Whys to be positioned not just as “another AI” or integration but as something beyond AGI — a specialized, value-creating intelligence layer for MSMEs and transformation.</p>
            </div>

            {/* Concept Note */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Concept Note</h3>
              <p className="text-white">Think5Whys is the world’s first dual-purpose intelligence ecosystem that goes beyond Artificial General Intelligence (AGI) by embedding Artificial MSME Intelligence (AMI) and Artificial Transformation-as-a-Platform Intelligence (ATaP-I).</p>
            </div>

            {/* AMI Section */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Artificial MSME Intelligence (AMI)</h3>
              <p className="text-white">Tailored for the unique realities of micro, small, and medium enterprises, AMI provides contextual, actionable, and resource-sensitive intelligence. It enables MSMEs to overcome barriers like limited cash flow, compliance complexity, and resource scarcity — empowering them to scale sustainably in competitive markets.</p>
            </div>

            {/* ATaP-I Section */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Artificial Transformation-as-a-Platform Intelligence (ATaP-I)</h3>
              <p className="text-white">Moving beyond consulting or point solutions, ATaP-I delivers continuous, AI-driven business transformation. It acts as a living platform that diagnoses, guides, and executes improvement initiatives in operations, quality, innovation, and digitalization — democratizing transformation for organizations of all sizes.</p>
            </div>

            <p className="text-white">Together, Think5Whys combines deep diagnostic thinking (root cause analysis, 5 Whys methodology) with adaptive intelligence to create a self-evolving ecosystem for problem-solving, decision-making, and transformation.</p>

            {/* Positioning */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Positioning</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Think5Whys is not just AI — it is a transformative intelligence platform.</li>
                <li className='text-xs lg:text-sm'>Where AGI seeks to replicate human intelligence, Think5Whys transcends it by embedding business context, transformation logic, and MSME-specific wisdom into its core.</li>
                <li className='text-xs lg:text-sm'>Beyond AGI: While AGI is generic, Think5Whys is contextual, actionable, and purpose-driven.</li>
                <li className='text-xs lg:text-sm'>For MSMEs: It empowers the backbone of economies with intelligence previously accessible only to large enterprises.</li>
                <li className='text-xs lg:text-sm'>For Transformation: It offers a Transformation-as-a-Platform model that is continuous, scalable, and democratized.</li>
              </ul>
              <p className="text-white italic">“Think5Whys – From Why to Wisdom. Empowering MSMEs. Democratizing Transformation. Beyond AGI.”</p>
            </div>

            {/* Value Addition over AGI */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Value Addition over AGI</h3>
              <div className="grid grid-cols-2 gap-2 text-xs text-gray-300">
                <div className="p-2 bg-gray-800/30 rounded">AGI<br/><span className="text-gray-400">Human-like intelligence.</span></div>
                <div className="p-2 bg-gray-800/30 rounded">Think5Whys<br/><span className="text-gray-400">Human + Business + Transformation intelligence in one ecosystem.</span></div>
              </div>
              <p className="text-white mt-2">Value Leap: Contextual → Actionable → Scalable → Sustainable. Think5Whys thus positions itself as the next frontier in applied intelligence, enabling micro and small enterprises, as well as organizations of all sizes, to continuously evolve, adapt, and thrive in an uncertain world.</p>
            </div>

          </div>
        )}


        {activeTab === 'sickunit' && (
          <div className="space-y-3">

            {/* Main Heading */}
            <div className="space-y-2">
              <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">
                India – Sick MSME Units & Revival Context
              </h2>
              <p className="text-white text-xs lg:text-sm">
                Overview of sick units in India, NPA trends, and potential for structured turnaround using Think5Whys.
              </p>
            </div>

            {/* Sick Unit Definition */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Definition of a Sick Unit</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'><strong>RBI:</strong> Units with cash losses and worsening financial ratios.</li>
                <li className='text-xs lg:text-sm'><strong>SICA 1985:</strong> Industrial company with accumulated losses ≥ net worth after 5 years.</li>
                <li className='text-xs lg:text-sm'><strong>MSEs:</strong> Accounts NPA ≥3 months or net worth erosion ≥50% in previous year.</li>
              </ul>
            </div>

            {/* Key Data 2020–2025 */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Key Data (2020–2025)</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Over 200,000 sick units; ₹7,000 crore in locked credit; ~29,000 units added yearly.</li>
                <li className='text-xs lg:text-sm'>Udyam cancellations (proxy for shutdowns): 73,576 by March 2023; 19,520 explicitly due to closure.</li>
                <li className='text-xs lg:text-sm'>State-wise top cancellations: Maharashtra (17,574), Tamil Nadu (6,570), Uttar Pradesh (6,265), Gujarat (6,115), Rajasthan (5,260).</li>
                <li className='text-xs lg:text-sm'>Sector-wise stress: Services (₹648.2B write-offs FY20-24), Manufacturing (₹437.9B), Trading (33% credit gap), Textiles & Food Processing high NPAs.</li>
              </ul>
            </div>

            {/* NPA Overview */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">MSME NPAs (as of March 31, 2025)</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Gross NPAs: 3.59% (~₹1.12 lakh crore) of ₹31.10 lakh crore total MSME credit.</li>
                <li className='text-xs lg:text-sm'>Micro: ₹52,519 crore, Small: ₹19,677 crore, Medium: ₹8,553 crore.</li>
                <li className='text-xs lg:text-sm'>5-year decline from 11.03% (FY20) → 3.59% (FY25); improvements driven by policy & digital reforms.</li>
                <li className='text-xs lg:text-sm'>Sector risk: Agriculture, Textiles, Gems & Jewelry, Food Processing remain vulnerable.</li>
              </ul>
            </div>

            {/* State-wise NPA Ratios (CGTMSE) */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">State-Wise NPA Ratios (FY25, CGTMSE)</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Lowest: Arunachal Pradesh (0.19%), Odisha (0.29%), Maharashtra (0.38%)</li>
                <li className='text-xs lg:text-sm'>Moderate: Haryana (0.48%), Karnataka (0.49%), Andhra Pradesh (0.64%)</li>
                <li className='text-xs lg:text-sm'>Higher: Manipur (0.72%), Kerala (0.77%)</li>
              </ul>
            </div>

            {/* ARCs & Sick Unit Revival */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Asset Reconstruction & Think5Whys Role</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>ARCs acquire NPAs to resolve or liquidate distressed MSME units.</li>
                <li className='text-xs lg:text-sm'>Think5Whys can provide structured management turnaround for micro & small units, complementing financial recovery.</li>
                <li className='text-xs lg:text-sm'>Stage 1 – Literacy: Improve financial literacy & systems.</li>
                <li className='text-xs lg:text-sm'>Stage 2 – Self-Management: Tools like RCA, Fishbone, Chronicle enhance cash flow & decision-making.</li>
                <li className='text-xs lg:text-sm'>Stage 3 – Managed Services: External monitoring & operational intervention to protect asset value.</li>
                <li className='text-xs lg:text-sm'>Alignment: Supports SARFAESI/ARC mandates by bridging financial restructuring and managerial turnaround.</li>
              </ul>
            </div>

            {/* Challenges */}
            <div className="space-y-2">
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Challenges & Considerations</h3>
              <ul className="list-disc list-inside space-y-1 text-white">
                <li className='text-xs lg:text-sm'>Adoption resistance from finance-focused ARCs/NBFCs.</li>
                <li className='text-xs lg:text-sm'>Promoter resistance at micro-enterprise level.</li>
                <li className='text-xs lg:text-sm'>Regulatory complexity limits “management takeover” in small units.</li>
              </ul>
            </div>

          </div>
        )}

         {activeTab === 'pmmy' && (
            <div className="space-y-3">

              {/* Header */}
              <div className="space-y-2">
                <h2 className="text-sm lg:text-lg font-semibold text-yellow-200">Think5Whys GrowSure & PMMY</h2>
                <p className="text-white">
                  An evolving Transformation-as-a-Platform leveraging AI and DeepTech to drive Kaizen beyond loans, supporting Governments, MLIs, and Micro-enterprises under PMMY.
                </p>
              </div>

              {/* Background */}
              <div className="space-y-2">
                <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Background: Pradhan Mantri MUDRA Yojana (PMMY)</h3>
                <p className="text-white font-medium">What is PMMY?</p>
                <p className="text-white">
                  Launched April 8, 2015, PMMY provides collateral-free credit to non-corporate, non-farm micro/small enterprises (manufacturing, trading, services). Loans disbursed via MLIs (PSBs, PVBs, RRBs, SFBs, MFIs, NBFCs) through MUDRA Ltd.
                </p>
                <p className="text-white font-medium">Categories & Limits:</p>
                <ul className="list-disc list-inside text-white space-y-1">
                  <li className='text-xs lg:text-sm'>Shishu: Up to ₹50,000</li>
                  <li className='text-xs lg:text-sm'>Kishore: ₹50,001 – ₹5,00,000</li>
                  <li className='text-xs lg:text-sm'>Tarun: ₹5,00,001 – ₹10,00,000</li>
                  <li className='text-xs lg:text-sm'>Tarun Plus: ₹10,00,001 – ₹20,00,000 (added July 2024; effective Oct 2024)</li>
                </ul>
                <p className="text-white font-medium">Benefits:</p>
                <ul className="list-disc list-inside text-white space-y-1">
                  <li className='text-xs lg:text-sm'>Formal credit access; reduced informal lender reliance</li>
                  <li className='text-xs lg:text-sm'>Focus on women/SC/ST/OBC borrowers</li>
                  <li className='text-xs lg:text-sm'>2% interest subvention for prompt Shishu repayments (12 months)</li>
                  <li className='text-xs lg:text-sm'>Mudra Card / App for working capital and ease of use</li>
                  <li className='text-xs lg:text-sm'>Supports self-employment and job creation</li>
                </ul>
              </div>

              {/* Gaps in PMMY */}
              <div className="space-y-2">
                <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Gaps in PMMY</h3>
                <ul className="list-disc list-inside text-white space-y-1">
                  <li className='text-xs lg:text-sm'>Concentration in Shishu limits scaling potential</li>
                  <li className='text-xs lg:text-sm'>Fraud/misuse: fake documents, ghost borrowers</li>
                  <li className='text-xs lg:text-sm'>Processing delays; inconsistent documents/fees</li>
                  <li className='text-xs lg:text-sm'>Limited post-loan support: mentoring, linkages</li>
                  <li className='text-xs lg:text-sm'>Weak monitoring: focus on quantity over quality, poor tracking of growth/jobs</li>
                </ul>
              </div>

              {/* How Think5Whys Fills Gaps */}
              <div className="space-y-2">
                <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">How Think5Whys Fills Gaps</h3>
                <p className="text-white">
                  Think5Whys, positioned as Transformation-as-a-Platform, leverages root-cause tools (5 Whys) to support MLIs and micro-enterprises.
                </p>
                <ul className="list-disc list-inside text-white space-y-1">
                  <li className='text-xs lg:text-sm'><strong>Reduce Fraud & Ensure Fund Use:</strong> 5-Whys on defaults; verification checklist, training, red-flag scoring; output → 1-page Fraud Red Flags card.</li>
                  <li className='text-xs lg:text-sm'><strong>Speed Up Processing:</strong> Process-mapping workshops; eKYC & single-window checklists; output → Process map + 3 fixes, TAT reduction tracking.</li>
                  <li className='text-xs lg:text-sm'><strong>Enable Scaling (Shishu → Tarun):</strong> 5-Whys on non-scaling borrowers; Growth Roadmap module; output → 4-session bootcamp + KPI dashboard.</li>
                  <li className='text-xs lg:text-sm'><strong>Post-Disbursement Handholding:</strong> Monthly health checks, peer groups; output → 6-month playbook + mobile checklist.</li>
                  <li className='text-xs lg:text-sm'><strong>Strengthen Monitoring & Metrics:</strong> Define KPIs; 5-Whys on data gaps; output → KPI matrix + M&E SOP + dashboard template.</li>
                </ul>
              </div>

              {/* Quick Pilot */}
              <div className="space-y-2">
                <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Quick Pilot (3–4 Weeks for MLI)</h3>
                <ul className="list-disc list-inside text-white space-y-1">
                  <li className='text-xs lg:text-sm'><strong>Week 0:</strong> Define branch objectives (e.g., 30% TAT cut)</li>
                  <li className='text-xs lg:text-sm'><strong>Week 1:</strong> 2 half-day workshops (process mapping, defaults)</li>
                  <li className='text-xs lg:text-sm'><strong>Week 2:</strong> Implement fixes & handhold 25 Shishu borrowers</li>
                  <li className='text-xs lg:text-sm'><strong>Weeks 3–4:</strong> Measure, iterate, 1-page report</li>
                </ul>
              </div>

              {/* PMMY Fraud & Verification Checklist */}
              <div className="space-y-2">
                <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">PMMY Fraud & Verification Checklist (Think5Whys Toolkit)</h3>
                <p className="text-white font-medium">Purpose:</p>
                <p className="text-white">Minimize fraud; ensure genuine fund use.</p>
                <ol className="list-decimal list-inside text-white space-y-1">
                  <li className='text-xs lg:text-sm'><strong>Borrower ID:</strong> e-KYC Aadhaar, PAN cross-check, photo match, linked mobile</li>
                  <li className='text-xs lg:text-sm'><strong>Business Proof:</strong> Site visit (Kishore+), signboard/stock/GST/Udyam, 1 reference</li>
                  <li className='text-xs lg:text-sm'><strong>Financials:</strong> 6-month statements, loan ≤2–3x turnover, no duplicates</li>
                  <li className='text-xs lg:text-sm'><strong>Invoices:</strong> Supplier GSTIN/call validation; recent/relevant</li>
                  <li className='text-xs lg:text-sm'><strong>Red Flags (Escalate ≥2):</strong> Hesitant applicant, no online footprint, round deposits, inconsistent answers</li>
                  <li className='text-xs lg:text-sm'><strong>Post-90 Days:</strong> Confirm fund usage, testimonial, Mudra Card trace</li>
                  <li className='text-xs lg:text-sm'><strong>Log:</strong> App ID/Date/Officer/Flags</li>
                </ol>
              </div>

              {/* Mock Case Example */}
              <div className="space-y-2">
                <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">Mock Case Example: "Cash Spike Shishu" (₹40,000 Loan)</h3>
                <p className="text-white">
                  <strong>Borrower:</strong> Ramesh Kumar, Tailoring shop<br/>
                  <strong>Docs:</strong> Aadhaar/PAN; 6-month statements (sudden ₹40k + ₹25k deposits, low sales); invoice (₹38k machine, post-deposit); no shop photo<br/>
                  <strong>Red Flags:</strong> Cash injections, immediate supplier pay, unreachable supplier, low activity<br/>
                  <strong>5 Whys Analysis:</strong> Deposits → Fake liquidity → No real funds → Fictitious business → Collusive transaction<br/>
                  <strong>Action:</strong> Site visit (48h), supplier verification (GST/challan), hold disbursement; escalate if unverifiable
                </p>
              </div>

            </div>
          )}

      </div>
    </div>
  );
};

export default MSMEVisionPage;